import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ErrorMessageModalComponent } from '../../modals/error-message-modal/error-message-modal.component'
import { PopupMessageModalComponent } from '../../modals/popup-message-modal/popup-message-modal.component'

import { SiteService } from '../../../services/site.service'
import { MessageService } from '../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../services/customer-requests.service'
import { ICustomerAccountValidationResult } from '../../../types/customerAccountValidationResult'
import { CustomerChangeRequestTypes } from '../../../enumeration'

@Component({
    selector: 'app-request-account-validation',
    templateUrl: './request-account-validation.component.html',
    styleUrls: ['./request-account-validation.component.scss'],
    standalone: false
})
export class RequestAccountValidationComponent implements OnInit 
{
  @ViewChild('customForm') public customForm: NgForm
	formSubmitted: boolean = false
	invalidForm: boolean = false

  emailPattern = "^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$"
	phoneNumberPattern = "^[0-9]{10,10}$"
  //postalcodePattern = "^[a-zA-Z0-9]{6,6}$"
  postalcodePattern = "^[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]$"
	vinPattern = "^[a-zA-Z0-9]{17,17}$"
  accountNumberPattern = "^[0-9]{10,10}$"
  paymentAmountPattern = "^[0-9.]{0,10}$"
  customer =
	{
		lastName: '',
		firstName: '',
    postalCode: '',
    phoneNumber: '',
    emailAddress: '',
		serialNumber: '',
		accountNumber: '',
		paymentAmount: undefined
	}
  customerAccountValidationResult: ICustomerAccountValidationResult

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 

  }

  ngOnInit() 
  {
    if(this.siteService.isLockedOut)
    {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '500px',
      dialogConfig.data = {
        title: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_TITLE'),
        message: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_BODY_LOCK'),
      }
      
      this.dialog.open(ErrorMessageModalComponent, dialogConfig)
      this.router.navigate(['/contact-us'])
    }
  }

  submitForm(customerForm: NgForm)
	{
		this.formSubmitted = true

		this.validateForm()
		if (customerForm.invalid || this.invalidForm == true)
		{
			return
		}

		this.messageService.startedHttpRequest('submitForm')
    this.customerRequestsService
      .validateCustomerAccount(this.customer)
      	.subscribe({
          next: (validationResult) =>
          {
            this.customerAccountValidationResult = validationResult
            this.siteService.setLoginSession(this.customerAccountValidationResult, undefined)

            if(this.customerAccountValidationResult.accountKnowledgeValidated)
            {
              return this.customerRequestsService.checkChangeRequestsAndProceed(this.siteService.customerRequestType)
              .then((result) =>
              {
                if(result)
                {
                  switch (this.siteService.customerRequestType)
                  {
                    case CustomerChangeRequestTypes.BankAccountChange:
                      this.router.navigate(['/bank-account-change'])
                      break
                    case CustomerChangeRequestTypes.NameChange:       
                      this.router.navigate(['/name-change'])
                      break
                    case CustomerChangeRequestTypes.PaymentDateChange:       
                      this.router.navigate(['/payment-date-change'])
                      break
                    case CustomerChangeRequestTypes.AddressChange:       
                      this.router.navigate(['/address-change'])
                      break
                    case CustomerChangeRequestTypes.PhoneChange:       
                      this.router.navigate(['/phone-change'])
                      break
                    case CustomerChangeRequestTypes.EmailChange:       
                      this.router.navigate(['/email-change'])
                      break
                    case CustomerChangeRequestTypes.OtherRequest:       
                      this.router.navigate(['/other-change'])
                      break
                    case CustomerChangeRequestTypes.LeaseTransfer:       
                      this.router.navigate(['/lease-transfer'])
                      break
                    case CustomerChangeRequestTypes.Unknown:
                      this.router.navigate(['/request-list'])
                      break             
                  }
                }
                else
                {
                  this.router.navigate(['/request-list'])
                }
              })
            }
            else
            {
              if(this.siteService.isLockedOut)
              {
                const dialogConfig = new MatDialogConfig()
                dialogConfig.width = '500px',
                dialogConfig.data = {
                  title: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_TITLE'),
                  message: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_BODY_LOCK'),
                }
                
                this.dialog.open(ErrorMessageModalComponent, dialogConfig)

                this.router.navigate(['/contact-us'])
              }
              else
              {
                const dialogConfig = new MatDialogConfig()
                dialogConfig.width = '500px',
                dialogConfig.data = {
                  title: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_TITLE'),
                  message: this.translateService.instant('REQUEST_ACCOUNT_VALIDATION_ERR_BODY'),
                }
                
                this.dialog.open(ErrorMessageModalComponent, dialogConfig)
              }
            }

            this.formSubmitted = false
          },
          error: (error) =>
          {
            this.messageService.completedHttpRequest('submitForm')
            
            const dialogConfig = new MatDialogConfig()
              dialogConfig.width = '500px',
              dialogConfig.data = {
                title: this.translateService.instant('COMMON_LBL_ERROR'),
                message: this.translateService.instant('COMMON_LBL_ERROR_MSG'),
            }
            
            this.dialog.open(ErrorMessageModalComponent, dialogConfig)
          },
          complete: () =>
          {
            this.messageService.completedHttpRequest('submitForm')
          }
        })
	}

	validateForm()
	{
		this.invalidForm = false

		if(this.customer.accountNumber == '' && this.customer.serialNumber == '' && (this.customer.paymentAmount == undefined || this.customer.paymentAmount == ''))
		{
			this.invalidForm = true
		}
	}

  postalCodeValidator(event: any) 
	{
		const pattern = /^[a-zA-Z0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, "")
			this.customer.postalCode = event.target.value
		}
	}

	phoneValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, "")
			this.customer.phoneNumber = event.target.value
		}
	}
}
